module.exports = __webpack_public_path__ + "static/media/web.2b39cf55.config";